/** All available budget request adjustment types */
export enum BudgetRequestAdjustmentTypeEnum {
  /** Increase plan */
  INCREASE = 'INCREASE',
  /** Decrease plan */
  DECREASE = 'DECREASE',
}
